import {
  Box,
  TextAction,
  VisuallyHidden,
  Icon,
} from '@leagueplatform/genesis-core';
import { useIntl } from '@leagueplatform/locales';
import pdfIcon from 'assets/pdf-icon.svg';
import { isPdfUrl } from 'utils/helpers';

export const FormCenterCard = ({
  title,
  linkUrl,
}: {
  title: string;
  linkUrl: string;
}) => {
  const { formatMessage } = useIntl();
  const isPdf = isPdfUrl(linkUrl);

  return (
    <TextAction
      href={linkUrl}
      target="_blank"
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '16px',
        textAlign: 'left',
        fontSize: '$bodyTwo',
        fontWeight: 'normal',
        color: '$onSurfaceTextSubdued',
        border: '1px solid #E0E3E6',
        backgroundColor: '$surfaceCardSecondary',
        borderRadius: '9px',
        '&:hover': {
          textDecoration: 'none',
        },
      }}
    >
      <Box
        css={{
          flex: 1,
          typography: '$subtitleOne',
          marginTop: '$half',
          paddingRight: '$two',
        }}
      >
        {title}
      </Box>
      {linkUrl && (
        <>
          {isPdf ? (
            <img
              src={pdfIcon}
              alt="PDF"
              style={{
                marginLeft: '6px',
                flexShrink: 0,
                width: '16px',
                height: '16px',
              }}
            />
          ) : (
            <Icon
              icon="interfaceExternalLink"
              size="$one"
              css={{
                marginLeft: '6px',
                flexShrink: 0,
                color: '$interactiveActionPrimary',
              }}
            />
          )}
          <VisuallyHidden data-testid="new-tab-msg">
            {formatMessage({ id: 'STR_OPENS_IN_A_NEW_TAB' })}
          </VisuallyHidden>
        </>
      )}
    </TextAction>
  );
};
